/**
 * Exports a Redux middleware that logs actions & store state to Sentry.
 *
 */

import createSentryMiddleware from "redux-sentry-middleware";
import * as Sentry from "@sentry/react";

// These action types will not be added to breadcrumbs, since they would clutter the logs
const breadcrumbActionBlacklist = [];

// These keys will be redacted from entity object in state
const entityTypeBlacklist = [];

/**
 * Reduces size of entities object from Redux state by converting each entity object into an array
 * of its keys. For instance, entities.kits will be an array of kit UUIDs, instead of objects
 * containing all kit data
 * @param {object} entities
 */
const flattenEntities = function (entities) {
  const flatEntities = {};
  Object.keys(entities).forEach(key => {
    if (entityTypeBlacklist.includes(key)) {
      flatEntities[key] = "(redacted)";
    } else {
      flatEntities[key] = Object.keys(entities[key]);
    }
  });
  return flatEntities;
};

export default createSentryMiddleware(Sentry, {
  stateTransformer: function (state) {
    return { ...state, entities: flattenEntities(state.entities) };
  },
  actionTransformer: function (action) {
    if (action?.response?.entities) {
      return {
        ...action,
        response: { ...action.response, entities: flattenEntities(action.response.entities) },
      };
    }
    return action;
  },
  filterBreadcrumbActions: function (action) {
    return !breadcrumbActionBlacklist.includes(action.type);
  },
  getUserContext: function (state) {
    const user = state.user;
    if (!user.id) return {};
    return {
      id: user.id,
      email: user.email,
      username: user.name,
    };
  },
});
